import script from "./AppStart_PC.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStart_PC.vue?vue&type=script&setup=true&lang=js"

import "./AppStart_PC.vue?vue&type=style&index=0&id=7e80cb0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e80cb0a"]])

export default __exports__